import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { Button } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faPodcast, faEdit, faBook } from '@fortawesome/free-solid-svg-icons';
import { LoadingSpinnerModal, ConfirmModal } from '../../components/dab';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css'; 
import { showAlert } from "../common/functions";
import { languageAction } from '../../actions/languageAction';

interface ILanguageProps {
	dispatch: Dispatch<any>;
	languageData: any;
}

const LanguageList: React.SFC<ILanguageProps> = ({
	dispatch, languageData }) => {

	const history = useHistory()

	const [selectedId, setSelectedId] = useState("");
	const [languageList, setLanguageList] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [isLanguagesLoaded, setIsLanguagesLoaded] = useState(false);
	const [isLanguageDeleted, setIsLanguageDeleted] = useState(false);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleDeleteModal = (value: boolean, isModelClose: boolean) => {
		if (value) {
			setIsLanguageDeleted(false);
			setIsLanguagesLoaded(true);
			dispatch(languageAction.languageDelete(selectedId));
			setShowModal(true);
		}
		setShowDeleteModal(false);
	};

	const handleForDelete = (id: string) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	}

	const handleListFilter = (langCode: string) => {
		localStorage.setItem("langCode", JSON.stringify(langCode));
	}

	React.useEffect(() => {
		dispatch(languageAction.languageGetByfilter());
		setShowModal(true);
	}, []);

	if (languageData) {
		if (languageData.isSuccess && !isLanguagesLoaded) {
			setShowModal(false);
			setIsLanguagesLoaded(true);
			setLanguageList(languageData.items);
		}

		if (languageData.isError && !languageData.isSuccess ) {			
			if (languageData.status === 'Unauthorized') {
				history.push({ pathname: '/401', state: 'language' });
			} else {
				showAlert(languageData.status, true);
			}
			languageData.isError = false;
			setShowModal(false);
		}

		if (languageData.isLanguageDeleted && languageData.isSuccess && !isLanguageDeleted) {
			setShowModal(false);
			showAlert(languageData.status, !languageData.isSuccess);
			setIsLanguageDeleted(true);
			setIsLanguagesLoaded(false);
			languageData.isSuccess = false;
			dispatch(languageAction.languageGetByfilter());
		}
	}

	return (
		<div className="language-list">
			<div className='card-box'>				
				<Button data-testid="createNewLanguage" id="submit" className="btn-submit-frm" onClick={() => { window.location.href = "/language?page=add"; }}>Create New</Button>	
			</div>
			<div style={{ paddingTop: '20px' }}>
				<table data-testid="languagesTable" className="table table-hover text-center">
					<thead data-testid="languageHead">
						<tr data-testid="languageHeaderBody">
							<th scope="col"data-testid="languageDetailHeader">Details</th>
							<th scope="col" data-testid="languageHeader">Language</th>
							<th scope="col" data-testid="languageChannelHeader">Channels</th>
							<th scope="col" data-testid="languageBiblesHeader">Bibles</th>
							<th scope="col" data-testid="languageDeteleHeader">Delete</th>
						</tr>
					</thead>
					<tbody data-testid="languageTableBody">
						{
							languageList && languageList.map((data: any) =>
								<tr key={data.languageCode} >
									<th scope="row">
										<FontAwesomeIcon cursor='pointer' size='2x' icon={faEdit}
										 title="Details" onClick={() => { window.location.href = "/language?id=" + data.languageCode }} />
									</th>
									<td id="languageName">{data.name}</td>
									<td >
										<a onMouseDown={() => handleListFilter(data.languageCode)} href={`/channel`} className="detail-link" data-testid="languageChannel">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faPodcast} data-bs-toggle="tooltip"
												data-bs-placement="bottom" title="channel" data-testid="languageChannelIcon"/>
										</a>
									</td>
									<td>
										<a onMouseDown={() => handleListFilter(data.languageCode)} href={`/bible`} className="detail-link" data-testid="languageBible">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faBook} data-bs-toggle="tooltip"
												data-bs-placement="bottom" title="Bible" data-testid="languageBibleIcon"/>
										</a>
									</td>
									<td data-testid="languageDeleteButton">
										<FontAwesomeIcon cursor='pointer' size='2x' icon={faTrashAlt} data-bs-toggle="tooltip"
											data-bs-placement="bottom" title="Delete" onClick={() => { handleForDelete(data.languageCode); }} />
									</td>
								</tr>
							)}
						{
							languageList.length<=0 &&
							<tr>
								<th scope="row" colSpan={5}>
									<h4> No data found </h4>
								</th>
							</tr>
						}
					</tbody>
				</table>
			</div>
			{
				showModal &&
				<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
			}
			<ConfirmModal isShowModal={showDeleteModal} deleteMessage={"Are you sure, Do you want to remove this language? "} modalChange={handleDeleteModal} />
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { languageData } = state;
	return {
		languageData
	};
};

export default connect(mapStateToProps)(LanguageList);